import React from 'react';
import StripeIcon from "../../../assets/icons/stripe.svg";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import Linked from "./Linked";
import { STRIPE_APP_ID } from '../../../data/integration-app';

const Stripe = ({connectedVenues}) => {
    return (
        <Col md="6" xxl="3" xl="4">
            <Link
            to="/integrations/stripe"
            className="int-col"
            >
            {connectedVenues.some(data => parseInt(data.app_id) === STRIPE_APP_ID) && <Linked />}    
            <div className="img">
                <img src={StripeIcon} alt="Stripe Payment " />
            </div>
            <div className="text">
                <h3>Stripe</h3>
                <p>
                Accept global payments with Stripe using credit cards, wallets, and more — fast and reliable.
                </p>
            </div>
            </Link>
        </Col>
    );
}

export default Stripe;